
const SvgComponent = ({
    ...props
}: React.SVGProps<SVGSVGElement>) => {
    const w = 32
    const h = 28
    return (
        <svg width={w} height={h} viewBox="0 0 32 28" fill="none" xmlns="http://www.w3.org/2000/svg"  {...props}>
            <path d="M24.3333 6V6C24.3333 3.23858 22.0948 1 19.3333 1H5.71154C3.10943 1 1 3.10943 1 5.71154V6M1 6H31V11.8333M1 6V26.8333H31V20.1667M31 11.8333C28.7778 11.2778 24.3333 11.3333 24.3333 16C24.3333 20.6667 28.7778 20.7222 31 20.1667M31 11.8333V20.1667" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}

export default SvgComponent
